import {type PIXI} from '@colonist/pixi'
import {UIGameMapEdgeController} from './UIGameMapEdgeController.ts'
import {type UIGameMapView} from './UIGameMapView.ts'
import {UIGameGeneralTileController} from './UIGameGeneralTileController.ts'
import {UIGameMapPortController} from './ui_game_map_port/UIGameMapPortController.ts'
import {UIGameMapCornerController} from './UIGameMapCornerController.ts'
import {UIGameMapViewBoundaries} from './UIGameMapViewBoundaries.ts'
import {type UIGameManager} from '../UIGameManager.ts'
import {type UIGameMapTileView} from './UIGameMapTileView.ts'
import {type UIGameMapHoverController} from './ui_game_map_hover/UIGameMapHoverController.ts'
import {type UIGameMechanic} from '../UIGameEventController.ts'
import {GameStateEnums} from '../../../../../shared/GameEnums.ts'
import {UIGameMapTileCenterHighlightController} from './ui_game_map_highlight/UIGameMapTileCenterHighlightController.ts'
import {UIGameMapTileEdgeHighlightController} from './ui_game_map_highlight/UIGameMapTileEdgeHighlightController.ts'
import {UIGameMapTileCornerHighlightController} from './ui_game_map_highlight/UIGameMapTileCornerHighlightController.ts'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {type HexFace} from '@colonist/game-mechanic-validators'

export abstract class UIGameMapController implements UIGameMechanic {
    protected readonly uiGameManager: UIGameManager

    readonly mapView: UIGameMapView
    readonly tileViews: UIGameMapTileView[]

    hoverController: UIGameMapHoverController
    cornerController: UIGameMapCornerController
    portController: UIGameMapPortController

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)

        this.mapView = this.initializeMapView()
        this.tileViews = []

        new UIGameMapTileCenterHighlightController(this.uiGameManager)
        new UIGameMapTileEdgeHighlightController(this.uiGameManager)
        new UIGameMapTileCornerHighlightController(this.uiGameManager)
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.CanvasResized: this.resizeMapView(); break
            default: break
        }
    }

    protected abstract initializeMapView(): UIGameMapView
    protected abstract resizeMapView(): void

    setInteractionEnabled(enabled: boolean) {
        if(enabled) this.mapView.enableInteraction()
        else this.mapView.disableInteraction()
    }

    createMap() {
        new UIGameMapViewBoundaries(this.uiGameManager)
        new UIGameGeneralTileController(this.uiGameManager)
        this.portController = new UIGameMapPortController(this.uiGameManager)
        this.cornerController = new UIGameMapCornerController(this.uiGameManager)
        new UIGameMapEdgeController(this.uiGameManager)
        this.mapView.sortChildren()
    }

    worldToScreenPoint(worldPoint: PIXI.Point) {
        return this.mapView.toScreen(worldPoint)
    }

    getTileViewForHexFace(hexFace: HexFace): UIGameMapTileView | undefined {
        for(const tileView of this.tileViews) {
            if(tileView.hexFace.sameFace(hexFace)) return tileView
        }
        return undefined
    }
}
